import i18n from '../../../i18n';
import { PartSlot } from '../../../partSlot';
import { parseBinding, useBoundData } from '../../../useBoundData';
import ProductCard from '../ProductCard/ProductCard';
import LoadingCard from '../ProductCard/LoadingCard';
import GroupCard from './GroupCard';

const parseFields = (value, fallback = []) => {
  if (!value) return fallback;
  if (Array.isArray(value)) return value;
  const raw = String(value).trim();
  if (!raw) return fallback;
  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) return parsed;
  } catch (error) {
    // CSV
  }
  return raw.split(',').map((item) => item.trim()).filter(Boolean);
};

const parseBool = (value, defaultValue = true) => {
  if (value === undefined || value === null || value === '') return defaultValue;
  const raw = String(value).toLowerCase().trim();
  if (['true', '1', 'yes', 'y', 'on'].includes(raw)) return true;
  if (['false', '0', 'no', 'n', 'off'].includes(raw)) return false;
  return defaultValue;
};

export default function FeaturedList({
  bindingId = '',
  binding: bindingProp = null,
  typeHint = '',
  flexWrap = true,
  fields = ['name', 'price', 'price_discount', 'variants', 'add_to_cart'],
  cardComponent = '',
}) {
  const parsed = parseBinding(bindingProp);
  const binding = bindingId
    ? {
      id: bindingId,
      type: parsed?.type || typeHint,
      mode: parsed?.mode || 'full',
      load: parsed?.load || 'eager',
      ids: parsed?.ids || [],
      items: parsed?.items,
      key: parsed?.key || bindingId,
    }
    : (parsed || { type: typeHint, mode: 'full', ids: [], load: 'eager' });
  const { items, loading } = useBoundData(binding);
  const wrap = parseBool(flexWrap, true);
  const wantedFields = parseFields(fields, ['name', 'price', 'price_discount', 'variants', 'add_to_cart']);
  const isProduct = (binding.type || typeHint) === 'product.Product';

  return (
    <div className="store-wrapper">
      <div className="store-row" style={wrap ? undefined : { flexWrap: 'nowrap', overflowX: 'auto' }}>
        {loading && items.length === 0 ? (
          [...Array(4).keys()].map((id) => <LoadingCard key={id} />)
        ) : items.length > 0 ? (
          items.map((item) => (
            isProduct ? (
              <PartSlot
                key={item?.id}
                id={cardComponent || 'ProductCard'}
                props={{ product: item, fields: wantedFields }}
              >
                <ProductCard product={item} fields={wantedFields} />
              </PartSlot>
            ) : (
              <GroupCard key={item?.id} group={item} />
            )
          ))
        ) : (
          <h5 className="ms-3">{i18n.t('No items found')}</h5>
        )}
      </div>
    </div>
  );
}
